export default __webpack_public_path__ + "static/media/icon_circle.9fbf68a8.jpeg";